"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _index = _interopRequireDefault(require("./Form/index"));
var _MessageCard = _interopRequireDefault(require("../../components/Cards/MessageCard"));
var _Loader = _interopRequireDefault(require("../../components/Loader"));
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MasterApplication = /*#__PURE__*/function (_PureComponent) {
  function MasterApplication() {
    var _this;
    (0, _classCallCheck2["default"])(this, MasterApplication);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, MasterApplication, [].concat(args)), _this.state = {
      masterAppData: null
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _inherits2["default"])(MasterApplication, _PureComponent);
  return (0, _createClass2["default"])(MasterApplication, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var masterAppData;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.props.getMasterApplicationData(this.props.currentAccountMeta.accountID);
            case 2:
              masterAppData = _context.sent;
              this.setState({
                masterAppData: masterAppData
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        currentAccountMeta = _this$props.currentAccountMeta,
        plan = _this$props.plan,
        setSelectedSection = _this$props.setSelectedSection,
        isReadOnly = _this$props.isReadOnly;
      if (!this.state.masterAppData) {
        return /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
          whitelabel: this.props.whitelabel
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isReadOnly && !this.props.sendRequestApprovalLink && /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].labels.masterApplication.readOnlyMode),
        subtitle: _i18n["default"].t(_tokens["default"].labels.masterApplication.readOnlyModeMessage)
      }), /*#__PURE__*/_react["default"].createElement(_index["default"], {
        whitelabel: this.props.whitelabel,
        currentAccountMeta: currentAccountMeta,
        data: this.state.masterAppData,
        plan: plan,
        isMasterSite: this.props.isMasterSite,
        setSelectedSection: setSelectedSection,
        isReadOnly: isReadOnly,
        updateMasterApp: this.props.updateMasterApp,
        completeMasterApp: this.props.completeMasterApp,
        sendRequestApprovalLink: this.props.sendRequestApprovalLink,
        displayError: this.props.displayError,
        isPrivateLabelAdvisor: this.props.isPrivateLabelAdvisor
      }), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: this.props.whitelabel
      }));
    }
  }]);
}(_react.PureComponent);
var _default = exports["default"] = MasterApplication;